import Utils from './utils.js';

/**
 * Class LocalStorage Visibility
 */
export default class LocalStorage {

	/**
	 * Handle cookie visibility conditions.
	 * Remove "hideClass" from element if it passed the cookie validation.
	 */
	handleLocalStorageVisibility( element, elementData, elementIsAllHide, showAllHideElement ) {

		// If item has already been shown
		if ( ! element.classList.contains( Utils.hideClass ) ) {
			return;
		}

		const localStorageSettings = elementData.local_storage_settings.local_storage || [];
		for ( const settingsEntry of localStorageSettings ) {
			const entryValue = window.localStorage.getItem( settingsEntry.name );
			if ( entryValue === settingsEntry.value ) {
				Utils.checkShowHide( settingsEntry, element, elementIsAllHide, showAllHideElement );
			}
		}

	}

}
